// import { formatDate } from '@angular/common';
// import { EventEmitter, Injectable, Output } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root',
// })
// export class CalendarService {
//   private dateObj?: Date;
//   @Output() dateUpdated = new EventEmitter<void>();
//   tab = '';
//   private isAllSubject = new BehaviorSubject<boolean>(false);
//   isAll$ = this.isAllSubject.asObservable();

//   constructor() {
//     this.resetDate();
//   }

// resetDate() {
//   this.dateObj = new Date();
//   this.isAllSubject.next(false);
//   sessionStorage.setItem(
//     'date',
//     formatDate(this.dateObj, 'yyyy-MM-dd', 'en_US'),
//   );
// }

// initDate() {
//   const storedDate = sessionStorage.getItem('date');
//   if (storedDate) {
//     this.dateObj = new Date(storedDate);
//   } else {
//     this.resetDate();
//   }
// }

//   set date(date: Date) {
//     this.dateObj = date || new Date();
//     this.isAllSubject.next(false);
//     sessionStorage.setItem(
//       'date',
//       formatDate(this.dateObj, 'yyyy-MM-dd', 'en_US'),
//     );
//     this.dateUpdated.emit();
//   }

//   get date() {
//     return this.dateObj || new Date();
//   }

//   dateString(format = 'yyyy-MM-dd', locale = 'en_US') {
//     if (!this.dateObj) {
//       return '';
//     }
//     return formatDate(this.dateObj, format, locale);
//   }

//   setAllSelected(isAll: boolean) {
//     this.isAllSubject.next(isAll);
//     if (isAll) {
//       this.dateObj = undefined;
//       sessionStorage.removeItem('date');
//     }
//   }

//   isAllSelected() {
//     return this.isAllSubject.getValue();
//   }
// }

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { formatDate } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CalendarService {
  private dateSubject = new BehaviorSubject<Date | null>(null);
  private isAllSubject = new BehaviorSubject<boolean>(false);

  date$ = this.dateSubject.asObservable();
  isAll$ = this.isAllSubject.asObservable();

  constructor() {
    this.loadFromSession();
  }

  loadFromSession() {
    const storedDate = sessionStorage.getItem('calendar_date');
    const storedIsAll = sessionStorage.getItem('calendar_isAll');

    if (storedIsAll === 'true') {
      this.setAllSelected(true, false);
    } else if (storedDate) {
      const date = new Date(storedDate);
      if (!isNaN(date.getTime())) {
        this.dateSubject.next(date);
        this.isAllSubject.next(false);
      } else {
        this.setToday(); // fallback
      }
    } else {
      this.setToday();
    }
  }

  private persist() {
    const date = this.dateSubject.getValue();
    const isAll = this.isAllSubject.getValue();

    if (isAll) {
      sessionStorage.setItem('calendar_isAll', 'true');
      sessionStorage.removeItem('calendar_date');
    } else {
      sessionStorage.setItem('calendar_isAll', 'false');
      if (date) {
        sessionStorage.setItem(
          'calendar_date',
          formatDate(date, 'yyyy-MM-dd', 'en-US'),
        );
      }
    }
  }

  /** Sets "Overall" mode */
  setAllSelected(isAll: boolean, persist = true) {
    this.isAllSubject.next(isAll);
    if (isAll) {
      this.dateSubject.next(null);
    } else {
      sessionStorage.setItem('calendar_isAll', 'false');
    }
    if (persist) this.persist();
  }

  /** Sets specific month and year */
  setMonth(month: number, year: number) {
    const date = new Date(year, month, 1);
    this.dateSubject.next(date);
    this.isAllSubject.next(false);
    this.persist();
  }

  /** Sets today's date (default init fallback) */
  setToday() {
    const today = new Date();
    this.setMonth(today.getMonth(), today.getFullYear());
  }

  /** Getters */
  getDate(): Date | null {
    return this.dateSubject.getValue();
  }

  isAllSelected(): boolean {
    return this.isAllSubject.getValue();
  }

  /** Get formatted string for current date */
  getFormattedDate(format = 'yyyy-MM-dd', locale = 'en-US'): string {
    const date = this.getDate();
    return date ? formatDate(date, format, locale) : '';
  }

  /** Get current month index or null */
  getMonth(): number | null {
    const date = this.getDate();
    return date ? date.getMonth() : null;
  }

  /** Get current year or null */
  getYear(): number | null {
    const date = this.getDate();
    return date ? date.getFullYear() : null;
  }
}
